module.exports = __webpack_public_path__ + "img/Icon-19.e6519d7f.png";